import * as React from 'react';
import './App.css';
import CssBaseline from '@mui/material/CssBaseline';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Toolbar from '@mui/material/Toolbar';
import Paper from '@mui/material/Paper';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Code from './components/code';
import Video from './components/video';
import Final from './components/final';
import Content from './components/content';


function App() {

  const steps = ['Enter Code', 'See Content', 'Thanks for Viewing'];

  const [activeStep, setActiveStep] = React.useState(0);

  const [count, setVideoCount] = React.useState(0);

  const handleNext = () => {
    setActiveStep(activeStep + 1);
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };


  function getStepContent(step) {
    switch (step) {
      case 0:
        return <Code advanceFunction={handleNext}/>;
      case 1:
        return <Video advanceForward={handleNext}/>;
      case 2:
        return <Final />;
      default:
        throw new Error('Unknown step');
    }
  }

  const theme = createTheme();

function Checkout() {


  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Container component="main" maxWidth="sm" sx={{ mb: 4 }}>
        <Paper variant="outlined" sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 } }}>
          <Typography component="h1" variant="h5" align="center">
          Enter code on your direct mailer to listen to our latest market broadcast. 
          </Typography>
          {/* <Typography component='h2' varient="h5" align='center' marginTop={2}>
          The code can be found in the "To" address field.
          </Typography> */}
          <Stepper activeStep={activeStep} sx={{ pt: 3, pb: 5 }}>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <React.Fragment>
            {activeStep === steps.length ? (
              <React.Fragment>
                <Typography variant="h5" gutterBottom>
                  Thank you for your order.
                </Typography>
                <Typography variant="subtitle1">
                  Your order number is #2001539. We have emailed your order
                  confirmation, and will send you an update when your order has
                  shipped.
                </Typography>
              </React.Fragment>
            ) : (
              <React.Fragment>
                {getStepContent(activeStep)}
                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                  {activeStep !== 0 && (
                    <Button onClick={handleBack} sx={{ mt: 3, ml: 1 }}>
                      Back
                    </Button>
                  )}
                  {/* <Button
                    variant="contained"
                    onClick={handleNext}
                    sx={{ mt: 3, ml: 1 }}
                  >
                    {activeStep === steps.length - 1 ? 'Place order' : 'Next'}
                  </Button> */}
                </Box>
              </React.Fragment>
            )}
          </React.Fragment>
        </Paper>
      </Container>
    </ThemeProvider>
  );
  }


  return (

    <div className="App">
      <header className="App-header">
          <div className='App-image'>
            <img src='assets/images/ag-marketing.png'  className='img'/>
          </div>
      </header>
      <Checkout/>
      <Content/>
      <div className='spacer'></div>

    </div>
  );
}

export default App;
